"use client";

import { IconForwardArrow } from "@repo/assets/images";
import { CkoPaySkeleton, CurrencySymbol, StickyButtonWrapper } from "@repo/components";
import { useCkoPayment } from "@repo/lib/hooks/checkout";
import { Button, LoadingDots } from "@repo/ui";
import cx from "classnames";
import { useTranslations } from "next-intl";
const CheckoutOptionCKO = ({
  cart,
  selectedAddress,
  locale,
  beginPlaceOrder
}) => {
  const t = useTranslations("Common");
  const {
    cartTotal
  } = cart;
  const {
    containerRef,
    isPending,
    handleCkoPayButton,
    isCkoLoading
  } = useCkoPayment({
    cartTotal,
    selectedAddress,
    locale,
    beginPlaceOrder
  });
  return <div data-sentry-component="CheckoutOptionCKO" data-sentry-source-file="CheckoutOptionCKO.jsx">
      <div className="relative">
        {/* Skeleton overlay */}
        {isCkoLoading && <CkoPaySkeleton />}

        {/* Component container always rendered */}
        <div ref={containerRef} id="flow-container" className={isCkoLoading ? "opacity-0" : "opacity-100 transition-opacity duration-300"} />
      </div>
      <StickyButtonWrapper data-sentry-element="StickyButtonWrapper" data-sentry-source-file="CheckoutOptionCKO.jsx">
        <Button size="md" variant="primary" className={cx("relative min-w-full md:min-w-[205px]", {
        "ms-auto flex justify-center": isPending
      })} disabled={isPending} onClick={handleCkoPayButton} data-sentry-element="Button" data-sentry-source-file="CheckoutOptionCKO.jsx">
          {isPending ? <LoadingDots className="bg-black" /> : <span className={cx("flex items-center justify-center font-semibold", {
          "invisible leading-[0]": isPending
        })}>
              {t("Pay")}
              <span className="px-1">
                <CurrencySymbol value={cartTotal?.formattedTotal} variant="smallSpecial" />
              </span>
              <IconForwardArrow className="text-supportiveBlack ms-2 rtl:rotate-180" />
            </span>}
        </Button>
      </StickyButtonWrapper>
    </div>;
};
export default CheckoutOptionCKO;